export default {
    'Go to the next lesson': 'Перейти до наступного уроку',
    'Finish classwork': 'Закінчити класну роботу',
    'Educational material': 'Навчальні матеріали',
    'upload_file': 'Завантажити файл',
    'upload_file_title': 'Натисни або перетягни файл з комп’ютера щоб його завантажити',
    'upload_file_description': 'Ти можеш завантажити файли PNG, SVG. Максимальний розмір 5 GB',
    'remove': 'Видалити',
    'save_files': 'Зберегти',
    'file_uploaded_successfully': 'Файл успішно загружен',
    'file_deleted_successfully': 'Файл успішно видалений',
    'enter_your_message': 'Напишіть ваше повідомлення...',
    'group': 'Група',
    'small_lessons': 'Уроки',
    'lessons_attended': 'Кількість відвіданих уроків ',
    "It was missed": "Було пропущено",
    "It was visited": "Було відвідано",
    "Total classes": "Всього занять",
    "Work on the platform" : "Робота на платформі",
    "Course progress" : "Прогрес по курсу ",
    "Work in class" : "Робота на уроці",
    "Programs" : "Програми",
    "Lessons" : "Уроки",
    "Your progress" : "Ваш прогрес",
    "Hide" : "Приховати",
    "Missed Classes" : "Пропущені заняття",
    "Course textbooks": "Ресурси",
    "All lessons" : "Всі уроки",
    "Active tab" : "Активні",
    "On checking" : "На перевірці",
    "Completed" : "Завершені",
    "Listened" : "Прослухано",
    "NameProgram": "Назва",
    "Module" : "Модуль",
    "Status" : "Статус",
    "Progress" : "Прогрес",
    "Additional materials" : "Додаткові матеріали",
    "Homework" : "Домашня робота",
    "Lesson Mark" : "Оцінка за урок",
    "Module Mark" : "Оцінка за модуль",
    "Nothing to show": "Сповіщень немає",
    "Question": "Питання",
    "Comment": "Коментар",
    "Go to": "Перейти до",
    "Open a lesson": "Перейти",
    "Nothing to show or no filtering selected": "Нічого немає для відображення або фільтрування не вибрано",
};
